/* Carolina Prospectors: inline zoom inside the main product image frame (no lightbox). */
(function () {
  function bestSrc(img) {
    var ss = img.getAttribute('srcset');
    if (ss) {
      var best = null, bw = 0;
      ss.split(',').forEach(function (p) {
        var parts = p.trim().split(/\s+/), w = parseInt(parts[1], 10) || 0;
        if (w >= bw) { bw = w; best = parts[0]; }
      });
      if (best) return best;
    }
    return img.currentSrc || img.src;
  }
  function setup(container) {
    if (container.dataset.cpZoom) return;
    var img = container.querySelector('img');
    if (!img) return;
    container.dataset.cpZoom = '1';
    container.classList.add('cp-zoomable');
    var lens = document.createElement('div');
    lens.className = 'cp-zoom-lens';
    lens.setAttribute('aria-hidden', 'true');
    container.appendChild(lens);
    var SCALE = 2.5, active = false;
    function move(x, y) {
      var r = container.getBoundingClientRect();
      var px = Math.min(Math.max((x - r.left) / r.width, 0), 1) * 100;
      var py = Math.min(Math.max((y - r.top) / r.height, 0), 1) * 100;
      lens.style.backgroundPosition = px + '% ' + py + '%';
    }
    function on(x, y) {
      if (!lens.style.backgroundImage) lens.style.backgroundImage = 'url("' + bestSrc(img) + '")';
      lens.style.backgroundSize = SCALE * 100 + '%';
      active = true; container.classList.add('cp-zoom-active'); move(x, y);
    }
    function off() { active = false; container.classList.remove('cp-zoom-active'); }
    // Desktop: click toggles zoom, mouse move pans, leaving zooms out
    container.addEventListener('click', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (e.detail === 0) return;
      if (container.dataset.cpTouch) { delete container.dataset.cpTouch; return; }
      e.preventDefault(); e.stopPropagation();
      if (active) off(); else on(e.clientX, e.clientY);
    }, true);
    container.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' && active) move(e.clientX, e.clientY); });
    container.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') off(); });
    // Touch: tap toggles zoom, drag pans while zoomed (blocks carousel swipe only while zoomed)
    var sx = 0, sy = 0, moved = false;
    container.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; sx = t.clientX; sy = t.clientY; moved = false;
      if (active) e.stopPropagation();
    }, { passive: true, capture: true });
    container.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (Math.abs(t.clientX - sx) > 8 || Math.abs(t.clientY - sy) > 8) moved = true;
      if (active) { e.preventDefault(); e.stopPropagation(); move(t.clientX, t.clientY); }
    }, { passive: false, capture: true });
    container.addEventListener('touchend', function (e) {
      container.dataset.cpTouch = '1';
      if (moved) return;
      var t = e.changedTouches[0];
      if (active) off(); else on(t.clientX, t.clientY);
    }, { capture: true });
    container.addEventListener('pointerdown', function (e) { if (active && e.pointerType !== 'mouse') e.stopPropagation(); }, true);
  }
  function init(root) {
    (root || document).querySelectorAll('media-gallery .product-media-container--image').forEach(setup);
  }
  function offAll() { document.querySelectorAll('.cp-zoom-active').forEach(function (c) { c.classList.remove('cp-zoom-active'); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  // Re-init after variant changes re-render the gallery
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('slideshow-controls, .slideshow-control, button')) offAll(); }, true);
})();
